import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RegistrationService } from 'projects/services/src/app/API/registration.service';
import { UserService } from 'projects/services/src/app/API/user.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { USER_ROLES } from 'src/app/scheme-constants/scheme-constants';

@Component({
  selector: 'app-verify-otp-modal',
  templateUrl: './verify-otp-modal.component.html',
  styleUrls: ['./verify-otp-modal.component.css']
})
export class VerifyOtpModalComponent implements OnInit, OnChanges {
	verifyOtpForm: FormGroup;
	modalId = 'VERIFY_OTP_MODAL';
	@Input() submitButtonName: String = 'Submit';
	@Input() showModal: Boolean = false;
	@Output() showModalChange = new EventEmitter<boolean>();
	@Output() otpVarificationResponse = new EventEmitter<boolean>();

	@Input() label: { mobileInputLabel: string, emailInputLabel: string } =
		{ mobileInputLabel: 'Mobile One Time Password', emailInputLabel: 'Email One Time Password' }
	@Input() placeholder: { mobilePlaceholder: string, emailPlaceholder: string } =
		{ mobilePlaceholder: 'Enter Mobile One Time Password', emailPlaceholder: 'Enter Email One Time Password' }
	@Output() otpDataChange = new EventEmitter<any>();
	@Input() registerOnVerification = false;
	@Input() userInfo: any;
	@Output() userName = new EventEmitter<string>();
	@Input() userNameForVerifyOtp: any;
	@Input() userDataPayloadForOtpVerification: any;
	constructor(
		private formBuilder: FormBuilder,
		private userService: UserService,
		private registrationService: RegistrationService
	) {
		this.verifyOtpForm = this.formBuilder.group({
			phone: [null, [Validators.required]],
			email: [null, [Validators.required]]
		})
   }
	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		// this.openModal();
	}
	openModal() {
		Helpers.openModal(this.modalId);
	}
	getOtpData() {
		this.otpDataChange.emit(this.verifyOtpForm.value);
	}
	verifyOtp() {
		let userData;
		if (this.userDataPayloadForOtpVerification && this.userDataPayloadForOtpVerification.role) {
			userData = {
				phone: {
					mobile: this.userDataPayloadForOtpVerification.phone
				},
				email: this.userDataPayloadForOtpVerification.email,
				role: this.userDataPayloadForOtpVerification.role
			}
		} else {
			userData = {
				role: USER_ROLES.BEST_IN_CLASS_EMPLOYER,
			}
		}
		if (this.registerOnVerification) {
			this.registrationService.verifyOTP(this.verifyOtpForm.value, userData).subscribe(
				res => {
					this.userName.emit(res.userName);
					this.onVerificationSuccess();
				}
			)
		} else {
			const OTPs = {
				phone_otp: this.verifyOtpForm.value.phone,
				email_otp: this.verifyOtpForm.value.email,
			};
			this.userService.verifyOTP(this.userNameForVerifyOtp, OTPs).subscribe(res => {
				this.onVerificationSuccess();
			});
		}
	}

	onVerificationSuccess() {
		this.otpVarificationResponse.emit(true);
		this.resetModal();
	}

	resetModal() {
		Helpers.closeModal(this.modalId);
		this.showModal = false;
		this.showModalChange.emit(false);
		this.verifyOtpForm.reset();
	}

	cancel() {
		// Helpers.closeModal(this.modalId);
		// this.showModal = false;
		this.showModalChange.emit(false);
		this.resetModal();
	}

}
